import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Table, Form } from "react-bootstrap";
import { IWebinarDB } from "../components/MainForm/MainForm";
import { getEvents, setWebinarActive } from "../services/Webinar";
import { Broadcast, ChevronRight, Inbox } from "react-bootstrap-icons";
import { ILoader } from "../App";
import { root } from "../utils/Constants";

const webinarsList = [
    {
        id: "1",
        title: "Gemini Advanced: Potenzia le tue idee, semplifica il tuo lavoro",
        start_date: "2025-05-07T12:00:00Z",
        end_date: "2025-05-07T13:00:00Z",
        json_data: '{"canale": "Canale 1"}',
        teacher: "Valeria Rossini (Dinova)"
    },
    {
        id: "2",
        title: "Gemini in Google Workspace: L’AI che trasforma la tua produttività",
        start_date: "2025-06-04T12:00:00Z",
        end_date: "2025-04-06T13:00:00Z",
        json_data: '{"canale": "Canale 2"}',
        teacher: "Alessandra Borgonovo"
    },
    {
        id: "2",
        title: "NotebookLM: Organizza, analizza, crea — con l’AI al tuo fianco",
        start_date: "2025-07-02T12:00:00Z",
        end_date: "2025-07-02T13:00:00Z",
        json_data: '{"canale": "Canale 2"}',
        teacher: "Alessandra Borgonovo"
    },
];


interface Props {
    handleLoader: ILoader;
}

export default function Webinars({ handleLoader }: Props) {
    const navigate = useNavigate();
    const [webinarList, setWebinarList] = useState<IWebinarDB[]>([]);

    useEffect(() => {
        updateWebinar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const updateWebinar = async () => {
        handleLoader.setLoading(true);
        const data = await getEvents();
        data.status && setWebinarList(data.data);
        handleLoader.setLoading(false);
    };

    const onClickView = (webinarID: string) => {
        navigate(root + "webinar/" + webinarID);
    };

    const onToggleActive = async (webinarID: string, active: boolean) => {
        const res = await setWebinarActive(webinarID, active);
        if (res.status) {
            setWebinarList((list) => list.map((w) => (w.id === webinarID ? { ...w, active: active ? 1 : 0 } : w)));
        }
    };

    const activeCount = webinarList.filter((w) => w.active != 0).length;

    return (
        <>
            <div className="admin-page-header">
                <div>
                    <h1>Webinar</h1>
                    <p className="subtitle">
                        {webinarList.length} webinar, {activeCount} attivi
                    </p>
                </div>
            </div>

            <div className="admin-card">
                {webinarList.length === 0 ? (
                    <div className="admin-empty">
                        <Inbox />
                        <p>Non ci sono webinar in lista</p>
                    </div>
                ) : (
                    <div className="table-responsive">
                        <Table hover className="admin-table">
                            <thead>
                                <tr>
                                    <th>Titolo</th>
                                    <th>Data</th>
                                    <th>Canale</th>
                                    <th className="text-center">Attivo</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                {webinarList.map((elem, i) => {
                                    return (
                                        <tr key={i} className="clickable" onClick={() => onClickView(elem.id)}>
                                            <td>
                                                <div className="cell-title">{elem.title}</div>
                                                <div className="cell-mono">#{elem.id}</div>
                                            </td>
                                            <td className="text-nowrap">
                                                {new Date(elem.start_date).toLocaleDateString("it-IT", { timeZone: "UTC" })}
                                            </td>
                                            <td>
                                                <span className="admin-badge primary">
                                                    <Broadcast /> Canale {elem.channel}
                                                </span>
                                            </td>
                                            <td className="text-center" onClick={(e) => e.stopPropagation()}>
                                                <Form.Check
                                                    type="switch"
                                                    className="d-inline-block"
                                                    checked={elem.active != 0}
                                                    onChange={(e) => onToggleActive(elem.id, e.target.checked)}
                                                />
                                            </td>
                                            <td className="text-end">
                                                <Button variant="light" className="icon-btn" aria-label="Apri webinar">
                                                    <ChevronRight />
                                                </Button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                )}
            </div>
        </>
    );
}
